import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import moment from 'moment';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { exportarEmExcel } from '~/Utils/Helpers';

const formatarMoeda = v =>
  v == null
    ? '-'
    : Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

const formatarData = d => (d ? moment(d).format('DD/MM/YYYY') : '-');
const formatarNumero = v => (v == null ? '-' : v);

// Colunas do modo Analítico (detalhe por boleto/título — #Tlista enriquecida).
const COLUNAS_ANALITICO = [
  { title: 'Empreendimento', key: 'nome_familia', ordenacao: true },
  { title: 'Cliente', key: 'apelido_conta', ordenacao: true },
  { title: 'QL', key: 'quadra', align: 'center' },
  { title: 'PP', key: 'lote', align: 'center' },
  { title: 'Tipo', key: 'tipo_titulo', align: 'center' },
  { title: 'Motivo', key: 'motivo', align: 'center' },
  { title: 'Vencimento', key: 'data_vencimento', render: formatarData },
  { title: 'Pagamento', key: 'data_pagamento', render: formatarData },
  { title: 'Dias', key: 'dias', align: 'right', render: formatarNumero },
  {
    title: 'Vl. Recebido',
    key: 'valor_recebido',
    align: 'right',
    render: formatarMoeda,
  },
  { title: 'Juros', key: 'juros', align: 'right', render: formatarMoeda },
  { title: 'Total', key: 'tot', align: 'right', render: formatarMoeda },
  {
    title: '% Com.',
    key: 'perc_comissao',
    align: 'right',
    render: v => (v == null ? '-' : `${Number(v).toFixed(2)}%`),
  },
  { title: 'Comissão', key: 'comissao', align: 'right', render: formatarMoeda },
];

// Colunas do modo Sintético (agrupado por cobrador/cliente).
const COLUNAS_SINTETICO = [
  { title: 'Cliente', key: 'apelido_conta', ordenacao: true },
  { title: 'Qtd', key: 'quantidade', align: 'right' },
  {
    title: 'Total Recebido',
    key: 'total_recebido',
    align: 'right',
    render: formatarMoeda,
  },
  {
    title: 'Total Comissão',
    key: 'total_comissao',
    align: 'right',
    render: formatarMoeda,
  },
];

/**
 * ResultadoSimulacao — grade do resultado em TabelaDinamica. Analítico => detalhe por boleto;
 * Sintético => agrupado por cliente. Export CSV/Excel client-side (read-only, sem call extra).
 */
const ResultadoSimulacao = ({ resultado }) => {
  if (!resultado) return null;

  const analitico = resultado.analitico === true;
  const itens = resultado.itens || [];
  const resumo = resultado.resumo || [];
  const dados = analitico ? itens : resumo;
  const colunas = analitico ? COLUNAS_ANALITICO : COLUNAS_SINTETICO;

  const exportar = () => {
    const cabecalho = colunas.map(c => c.title);
    const linhas = dados.map(row =>
      colunas.map(c => {
        const valor = row[c.key];
        if (c.key === 'data_vencimento' || c.key === 'data_pagamento') {
          // W-0852: força texto no Excel (="dd/mm/aaaa") p/ não virar data e sair como ####
          return valor
            ? { __textoExcel: true, valor: moment(valor).format('DD/MM/YYYY') }
            : '';
        }
        return valor == null ? '' : valor;
      })
    );
    exportarEmExcel(
      [cabecalho, ...linhas],
      `simula-comissao-cobranca-${moment().format('YYYYMMDD')}.csv`
    );
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <strong>Total Recebido:</strong> {formatarMoeda(resultado.total_recebido)}{' '}
          &nbsp;|&nbsp; <strong>Total Comissão:</strong>{' '}
          {formatarMoeda(resultado.total_comissao)}
        </div>
        <Button
          variant="success"
          onClick={exportar}
          disabled={dados.length === 0}
          title="Exportar Excel"
        >
          <FaFileExcel className="mb-1" />{' '}
          <span className="ms-1">Exportar Excel</span>
        </Button>
      </div>

      <Tabela colunas={colunas} dados={dados} fontSize="13px" paginar itensPorPagina={20} />
    </div>
  );
};

export default ResultadoSimulacao;
